import React from 'react'

const informationIcon = '/assets/images/informationIcon.svg'

interface HoldValidationMessageProps {
  message?: string
}



const HoldValidationMessage: React.FC<HoldValidationMessageProps> = ({
  message = 'Cannot Hold Request: Start date is less than 15 days',
}) => {
  return (
    <div className="mb-6 flex items-center gap-2">
      <img src={informationIcon} alt="Information" className="w-5 h-5 flex-shrink-0" />
      <p className="text-sm">{message}</p>
    </div>
  )
}

export default HoldValidationMessage
